import { render, staticRenderFns } from "./noResultsIcon.vue?vue&type=template&id=03f57ccf"
import script from "./noResultsIcon.vue?vue&type=script&lang=js"
export * from "./noResultsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports